module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAASCAMAAABsDg4iAAAAAXNSR0IB2cksfwAAAAlwSFlzAAASdAAAEnQB3mYfeAAAAHhQTFRFAAAAf39/dnZ2f39/f39/f39/f39/f39/f39/f39/f39/gIB/gIB/f39/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/gIB/tVQ7MgAAACh0Uk5TAP8aD2tl3d8UbBBGSmYUE96RAUKniv/SCvA59z94+Xm4iwnm8vpk08FZ024AAAB8SURBVHicjdDZEoIwDIXhlLIVEXHhsKiACPL+byiMhQmlF/6X30zSToisiV0zOkY/3E6uKF1Pmih9IYLQQDWvV/9gtIwfYv6QOsqE6JSeL8S/dL0RZcgTjkVZFtUdeHB8om5aAC+G3RvohwlThh/o6gWnxkHX64PYTmfpC2YMB1LWEnUrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/online/picicon.png
// module id = 4k8s
// module chunks = 1